import React, { useEffect, useState, useRef } from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import Alert from '@mui/material/Alert';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Backdrop, CircularProgress } from '@mui/material';
import swal from 'sweetalert';
import DropIn from 'braintree-web-drop-in-react';
import Modal from 'react-bootstrap/Modal';
import cardImage from "../../../../src/assets/images/cdc-c.png"
import chipImage from "../../../../src/assets/images/cardChip.png"



function AddPaymentMethod() {
  const SERVER_URL = process.env.REACT_APP_API_URL;
  const [cards, setCards] = useState([]);
  const [cardToken, setCardToken] = useState("");
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false)
  const [loading, setLoading] = useState(false);
  const [clientToken, setClientToken] = useState("")
  const [modelVisibility, setModelVisibility] = useState(false)
  const instanceRef = useRef(null);
  const [deleteToken, setDeleteToken] = useState("")
  const[purchaseButton,setPurchaseButton]=useState(false)


  useEffect(() => {
    handleGetCards();
  }, []);

  const handleGetCards = async () => {
    try {
      setLoading(true)
      const header = await getApiHeader();
      const response = await axios.get(`${SERVER_URL}card/payment-methods`, { headers: header });
      if (response.status === 200) {
        setCards(response.data.data.payment_methods);
        setClientToken(response.data.data.client_token)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Error fetching cards:", error);
    }
  };

  const handleSelectCard = async () => {
    try {
      setLoading(true);
      setOpen(false);
      const header = await getApiHeader();
      const payload = { paymentMethodToken: cardToken };

      const response = await axios.post(`${SERVER_URL}card/set-default`, payload, { headers: header });
      if (response.status === 200) {
        setCards(prevCards =>
          prevCards.map(card =>
            card.token === cardToken
              ? { ...card, default: true }
              : { ...card, default: false }
          )
        );
        setLoading(false);
        let message = response?.data?.message
        if (message) {
          swal("Success", message);
        }


      }
    } catch (error) {
      setLoading(false);
      console.error("Error setting default card:", error);

      const message = error.response.data.message
      if (message) {
        swal("Error", message);
      }

    }
  };


  const deleteCard = async () => {
    setOpenDelete(false);

    try {
      setLoading(true);
      const header = await getApiHeader();
      const payload = { paymentMethodToken: deleteToken };  // Using deleteToken from state

      const response = await axios.post(`${SERVER_URL}card/delete`, payload, { headers: header });

      if (response.status === 200) {
        setCards((prevCards) => {
          const updatedCards = prevCards.filter((card) => card.token !== deleteToken);

          // If the deleted card was the default, set the next card as default
          if (prevCards.find(card => card.token === deleteToken)?.default && updatedCards.length > 0) {
            updatedCards[0] = { ...updatedCards[0], default: true };

            const newDefaultToken = updatedCards[0].token;
            setDefaultCardAPI(newDefaultToken);
          }

          const message = response?.data?.message;
          if (message) {
            swal("Success", message);
          }
          setLoading(false);
          return updatedCards;
        });
      }
    } catch (error) {
      setLoading(false);
      const message = error?.response?.data?.message;
      if (message) {
        swal("Error", message);
      }
      console.error("Error deleting card:", error);
    }
  };


  //  function to set the new default card
  const setDefaultCardAPI = async (token) => {
   
    try {
      setLoading(true)
      const header = await getApiHeader();
      const payload = { paymentMethodToken: token };

      const response = await axios.post(`${SERVER_URL}card/set-default`, payload, { headers: header });
      if (response.status === 200) {
        setLoading(false)

      }

    } catch (error) {
      setLoading(false)
      console.error("Error setting new default card:", error);
      const message = error.response.data.message
      if (message) {
        swal("Error", message);
      }
    }
  };


  const handleClientToken = async () => {
    setLoading(true)
    try {
      const header = await getApiHeader()
      const response = await axios.get(`${SERVER_URL}nbn/payments/get-client-token`, { headers: header })
      if (response.status === 200) {
        setClientToken(response?.data?.data?.clientToken)
        setTimeout(() => { setModelVisibility(true) }, 1000)

        setLoading(false)
      }
    } catch (error) {
      setLoading(false)

    }
  }







  const handlePaymentCard = async (e) => {
   
    e.preventDefault();
    if (!instanceRef.current) {
      return console.error('Braintree DropIn instance is not initialized');
    }
    try {
      setPurchaseButton(false)
      const { nonce } = await instanceRef.current.requestPaymentMethod();
      const payload = {
        payment_method_nonce: nonce,
      }
      const headers = await getApiHeader();

      const response = await axios.post(`${SERVER_URL}card/save`, payload, { headers });
      if (response.status === 200) {
        setModelVisibility(false)
       
      }else{
         setPurchaseButton(false)
      }

      let message = response?.data?.message
      swal("Success", message).then(() => {
        handleGetCards()
      });


    } catch (error) {

         if(error.message){
          setPurchaseButton(true)
         } 
       
      const message = error?.response?.data?.message
      // setModelVisibility(false)
      if (message) {
        setPurchaseButton(false)
        swal("Error", message);
        setModelVisibility(false)

      }
    }
  };



  const handlePaymentGateWay = () => {
     setLoading(true)
    if (clientToken == "") {
      return
    } else {
      setModelVisibility(true)

       setTimeout(()=>{setPurchaseButton(true) ,setLoading(false)},2000)
     
    }
  }




  const updateDefaultCard = (token) => {
    setCardToken(token);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const handleModalClose = () => {
    setModelVisibility(false)
  }

  const handleDeleteClose = () => {
    setOpenDelete(false)

  }

  const handleDeleteFunction = (token) => {
    setDeleteToken(token)
    setOpenDelete(true)
  }



















  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        {loading && (
          <Backdrop
            open={true}
            style={{
              color: '#fff',
              zIndex: 9999,
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        <div className="add-card-wrapper">
          <div>
            <div className="row">

              <div className="col-lg-6 col-md-6 col-sm-12">
                <h5 className='payment-method-label'>Payment Methods</h5>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <button className='AddCard-button' onClick={handlePaymentGateWay}>+ Add Card</button>
              </div>
              {cards.map((data, i) => (
                <div key={i} className="col-lg-4 col-md-6 col-sm-12">
                  <div className="card add-credit-card" >
                    <div style={{ backgroundImage: `url(${cardImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                      <div className="add-card-body">
                        <h5 className="card-title" style={{ margin: "0 0 10px" }}></h5>

                        <img
                          src={chipImage}
                          alt="Chip"
                          style={{
                            width: "50px",
                            marginBottom: "-60px"
                          }}
                        />
                        <p className="card-text" style={{ marginTop: "40px" }}><strong>Card No:</strong> {data?.maskedNumber}</p>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <p className="card-text" style={{width: "218px",wordBreak:"break-all"}}><strong>Name:</strong> {data?.cardholderName}</p> 
                          <p className="card-text" ><strong>Expiry:</strong> {data?.expirationDate}</p>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#fcf2f7" }}>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input" 
                          type="checkbox"
                          role="switch"
                          id={`flexSwitchCheckDefault-${i}`}
                          checked={data.default}
                          onChange={() => updateDefaultCard(data.token)}
                          title={!data.default ? "Make this card default" : ""}
                          disabled={data.default}
                        />
                        <label
                          className="form-check-label visually-hidden"
                          htmlFor={`flexSwitchCheckDefault-${i}`}
                        >
                          Toggle Default
                        </label>
                      </div>
                      <span role="button" style={{ color: "red", cursor: "pointer" }} onClick={() => { handleDeleteFunction(data.token) }}>
                        {/* Delete Icon */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#C11D6C"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </span>
                    </div>
                  </div>

                </div>
              ))}
            </div>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Confirm Default Card</DialogTitle>
              <DialogContent>
                <DialogContentText style={{ color:"rgba(0, 0, 0, .64)",fontSize:"20px",fontWeignt:"900"}} className='addPaymentMethodDailouge'>
                  Set this card as your default card?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}  style={{color:"white",backgroundColor:"#C11D6C"}}>
                  Cancel
                </Button>
                <Button onClick={handleSelectCard} style={{color:"white",backgroundColor:"#C11D6C"}} autoFocus>
                  Set as default
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={openDelete} onClose={handleDeleteClose}>
              <DialogTitle>Confirm Delete Card</DialogTitle>
              <DialogContent>
                <DialogContentText style={{color:"rgba(0, 0, 0, .64)"}} className='addPaymentMethodDailouge'>
                  Are you sure you want to delete this card
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDeleteClose} style={{color:"white",backgroundColor:"#C11D6C"}}>
                  Cancel
                </Button>
                <Button onClick={deleteCard}  style={{color:"white",backgroundColor:"#C11D6C"}} autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

          </div>
        </div>
      </DashboardLayout>

      <div>
        <Modal className="modal-fullscreen createAccount-modal" size='md' centered show={modelVisibility} onHide={handleModalClose} >
          <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Modal.Title style={{ color: "#000" }}>Add Card</Modal.Title>
            <button
              onClick={handleModalClose}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
                color: "#000"
              }}
            >
              &times;
            </button>

          </Modal.Header>
          <hr style={{ margin: 0, borderColor: "#ddd" }} />

          <Modal.Body>
            <div>
            <label className='dealer-responsive-label' >Please add payment card details of dealer. Do not add customer payment card details here. </label>
              <DropIn
                options={{
                  authorization: clientToken, card: { cardholderName: { 'required': true } }
                }}
                onInstance={(instance) => (instanceRef.current = instance)}
              />
            </div>
          </Modal.Body>
          {purchaseButton&&
          <Button variant="secondary" className='add-card-button' onClick={handlePaymentCard} style={{ margin: "20px", backgroundColor: "#C11D6C", color: "white", margin: "0 25px 10px 25px" }}   >
          Submit
        </Button>


          }
          
          <Modal.Footer>


            {/* <button className="btn btn-brand" id="saveBtn" onClick={confirmHandler}>Confirm & Submit</button> */}
          </Modal.Footer>
        </Modal>


      </div>
    </div>
  );
}

export default AddPaymentMethod;
